module.exports = __webpack_public_path__ + "img/article-defaultimg-small.16013260.png";